import React from 'react';
import { ILS } from '../../utils/salesUtils';

export default function BalanceCard({ remaining, total, onPayRest }) {
  const fullyPaid = remaining === 0 && total > 0;

  return (
    <div className={`pos-balance-card${fullyPaid ? ' paid' : ''}`}>
      <span className="pos-balance-ic">{fullyPaid ? '✅' : '⏳'}</span>
      <div className="pos-balance-body">
        <div className="pos-balance-label">
          {fullyPaid ? 'Pagado completo' : 'Saldo pendiente'}
        </div>
        <div className="pos-balance-amount">
          {fullyPaid ? ILS(total) : ILS(remaining)}
        </div>
      </div>
      {!fullyPaid && onPayRest && (
        <button className="pos-pay-rest-btn" onClick={onPayRest}>
          Pagar resto
        </button>
      )}
    </div>
  );
}
